import { combineReducers } from 'redux';
import authReducer from './authReducer';
import chatReducer from './chatReducer';
import socketReducer from './socketReducer';
import userReducer from './userReducer';
import baseApi from '../../api/baseApi';

export default combineReducers({
  auth: authReducer,
  user: userReducer,
  chat: chatReducer,
  socket: socketReducer,
  [baseApi.reducerPath]: baseApi.reducer
});
